import React, { useState } from 'react';
import styles from './LockingSystemModal.module.css';

const LockingSystemModal = ({ onClose, onSelect }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [manufacturer, setManufacturer] = useState('');

  const lockingSystems = [
    {
      id: 1,
      name: 'ICELOCK 651 - L - 651000',
      brand: 'Click medical',
      image: '/images/lock_type_1.png',
      customizable: true
    },
    {
      id: 2,
      name: 'REVOLOCK - xr13000 - 220',
      brand: 'Click medical',
      image: '/images/lock_type_2.png',
      customizable: true
    },
    {
      id: 3,
      name: 'Sangle Distale - DA - 001',
      brand: 'AddNxt',
      image: '/images/lock_type_3.png',
      customizable: false
    },
    {
      id: 4,
      name: 'REVOLOCK - xr13000 - 220',
      brand: 'Click medical',
      image: '/images/lock_type_4.png',
      customizable: true
    }
  ];

  // Filter locking systems based on search term
  const filteredSystems = lockingSystems.filter(system => 
    system.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    system.brand.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelect = (system) => {
    if (onSelect) {
      // Pass the system with customization disabled (normal toolcard)
      onSelect({
        ...system,
        customizationEnabled: false
      });
    }
    onClose();
  };

  const handleLetsGoClick = () => {
    if (onSelect) {
      // Pass a custom system with customization enabled
      onSelect({
        id: 'custom',
        name: 'Custom Distal lock',
        brand: 'Custom',
        image: '/images/custom.png',
        customizable: true,
        customizationEnabled: true
      });
    }
    onClose();
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        {/* Header */}
        <div className={styles.modalHeader}>
          <div className={styles.headerLeft}>
            <div className={styles.headerIcon}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z" fill="#7c3aed"/>
              </svg>
            </div>
            <h2>Select a locking system</h2>
          </div>
          <button className={styles.closeButton} onClick={onClose}>
            ✕
          </button>
        </div>

        {/* Search and Filter */}
        <div className={styles.searchSection}>
          <input
            type="text"
            placeholder="Search for"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className={styles.searchInput}
          />
          <input
            type="text"
            placeholder="Manufacturer"
            value={manufacturer}
            onChange={(e) => setManufacturer(e.target.value)}
            className={styles.searchInput}
          />
        </div>

        {/* Customization Notice */}
        <div className={styles.customizationNotice}>
          <div className={styles.noticeContent}>
            <p>You can't find your locking system?</p>
            <p>use a locking system with customisable measurements</p>
          </div>
          <button className={styles.letsGoButton} onClick={handleLetsGoClick}>
            Let's Go
          </button>
        </div>

        {/* Product Grid */}
        <div className={styles.productGrid}>
          {filteredSystems.map((system, index) => (
            <div 
              key={system.id}
              className={`${styles.productCard}`}
              onClick={() => handleSelect(system)}
            >
              <div className={styles.productInfo}>
                <h3>{system.name}</h3>
                <span className={styles.brandTag}>Brand</span>
                <p className={styles.brandName}>{system.brand}</p>
              </div>
              <div className={styles.productImage}>
                  <img src={system.image} alt={system.name} style={{
                    width: '100px',
                    height: '100px',
                    objectFit: 'cover'
                  }}/>
              </div>
            </div>
          ))}
        </div>

        {/* Show message if no results */}
        {filteredSystems.length === 0 && searchTerm && (
          <div style={{ 
            padding: '20px', 
            textAlign: 'center', 
            color: '#6b7280',
            fontStyle: 'italic'
          }}>
            No locking systems found matching "{searchTerm}"
          </div>
        )}
      </div>
    </div>
  );
};

export default LockingSystemModal; 